<template>
  <div class="game-container">
    <div id="game-container">
      <div class="image-container" v-if="objectImageExist(mainImage)">
        <div
          class="image"
          v-for="item in mainImage"
          :key="item.key"
          :style="'background-image: url(' + getImage(item) + ');'"
        ></div>
        <!-- :style="'background-image: url('+getImage(item)+');width:'+item.width+'px;;height:'+item.height+'px;'"> </div> -->
      </div>
      <canvas id="gameCanvas"></canvas>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-sortable-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      mainImage: this.startGameConfig.mainImage,
      stage: null,
      width: 0,
      height: 0,
      offset: {},
      images: [],
      indx: [],
      resize: false,
      ticker: false,
      movesTo: [],
      scale: 1,
    };
  },
  beforeMount() {},
  mounted() {
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    this.ticker = createjs.Ticker;
    this.ticker.framerate = 60;
    if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
    this.ticker.addEventListener('tick', this.tick);
    this.initGame();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    setStage() {
      this.initData = _.cloneDeep(this.startGameConfig);
      this.width = this.initData.width ? this.initData.width : document.getElementById('game-container').offsetWidth;
      this.height = this.initData.height
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
    },
    initGame() {
      this.resetCheckStatus();
      this.setStage();
      var container = new createjs.Container();
      container.name = 'target';
      if (this.initData.bgr.split('/').length == 1) {
        var shape = new createjs.Shape();
        shape.width = this.initData.width;
        shape.height = this.initData.height;
        shape.graphics.f(this.initData.bgr).dr(0, 0, shape.width, shape.height).ef();
        container.x = (this.width - shape.width) / 2 - this.offset.x;
        container.y = (this.height - shape.height) / 2 - this.offset.y;
        container.addChild(shape);
      } else {
        let queue = new preload.LoadQueue();
        var self = this;
        container.x = 0 - this.offset.x;
        container.y = 0 - this.offset.y;
        queue.on('fileload', function (e) {
          container.addChild(new createjs.Bitmap(e.result.src));
        });
        queue.on('complete', function (e) {
          self.stage.update();
        });
        queue.loadManifest([{ src: `static/${this.$store.getters.multibookType}/${this.initData.bgr}` }]);
      }
      this.stage.addChild(container);
      this.loadImages();
      this.stage.update();
    },
    loadImages() {
      var self = this;
      let pick = this.initData.pick
        ? this.initData.pick > this.initData.samples.length
          ? this.initData.samples.length
          : this.initData.pick
        : this.initData.samples.length;
      var indx = [];
      do {
        indx = [];
        for (let i = 0; i < pick; i++) {
          let ix = Math.round(Math.random() * (this.initData.samples.length - 1));
          let flg = false;
          for (let j = 0; j < indx.length; j++) if (indx[j] == ix) flg = true;
          if (flg) i--;
          else indx[i] = ix;
        }
        var ok = 0;
        if (this.initData.corrBlock) {
          for (let i = 0; i < indx.length; i++) {
            if (this.initData.correct[i] == this.initData.samples[indx[i]].id) ok++;
          }
        }
      } while (ok == indx.length);
      var images = [];
      indx.forEach(function (ind, i) {
        images[i] = Object.assign({}, self.initData.samples[ind]);
      });
      images = images.map((o) => {
        o.src = `static/${this.$store.getters.multibookType}/${o.src}`;
        return o;
      });
      var manifest = [];
      images.forEach(function (img, i) {
        if (self.initData.isHor) {
          img.pos = {
            x:
              (self.initData.margin.left ? self.initData.margin.left : 0) +
              (self.initData.sample.width + (self.initData.margin.lineH ? self.initData.margin.lineH : 15)) * i,
            y: self.initData.margin.top ? self.initData.margin.top : 0,
          };
        } else {
          img.pos = {
            x: self.initData.margin.left ? self.initData.margin.left : 0,
            y:
              (self.initData.margin.top ? self.initData.margin.top : 0) +
              (self.initData.sample.height + (self.initData.margin.lineH ? self.initData.margin.lineH : 15)) * i,
          };
        }
        manifest.push(img);
      });
      let queue = new preload.LoadQueue();
      queue.on('fileload', function (e) {
        self.handleFileLoad(e);
      });
      queue.on('complete', function (e) {
        let container = self.stage.getChildByName('target');
        self.images.forEach(function (bmp) {
          if (!bmp.parent) container.addChildAt(bmp, 1);
        });
        self.stage.update();
      });
      queue.loadManifest(manifest);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();
      this.images.splice(0, this.images.length);
      this.indx.splice(0, this.indx.length);
      this.movesTo.splice(0, this.movesTo.length);
      this.initGame();
      this.stage.update();
    },
    handleFileLoad(e) {
      var image = e.result;
      let bmp = new createjs.Bitmap(image.src);
      bmp.id = e.item.id;
      bmp.block = false;
      bmp.x = e.item.pos.x;
      bmp.y = e.item.pos.y;
      bmp.pos = { x: bmp.x, y: bmp.y };
      bmp.newPos = { x: bmp.x, y: bmp.y };
      bmp.ix = this.indx.length;
      bmp.move = false;
      this.indx.push({ x: bmp.x, y: bmp.y });
      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);
      let container = this.stage.getChildByName('target');
      container.addChildAt(bmp, 1);
      this.images.push(bmp);
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var ix = -1;
      this.images.forEach(function (bmp, i) {
        if (e.target.id == bmp.id) {
          ix = i;
        }
      });
      if (ix >= 0 && !this.images[ix].block) {
        this.images[ix].parent.setChildIndex(this.images[ix], this.images[ix].parent.children.length - 1);
        this.stage.update();
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.resize = this.images[ix];
        this.resize.stageX = e.stageX;
        this.resize.stageY = e.stageY;
        this.mousedown = true;
      } else this.resize = null;
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        this.resize.x += e.stageX - this.resize.stageX;
        this.resize.y += e.stageY - this.resize.stageY;
        this.resize.stageX = e.stageX;
        this.resize.stageY = e.stageY;
        this.resize.x = Math.round(this.resize.x);
        this.resize.y = Math.round(this.resize.y);
        var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);
        if (items.length > 2) {
          var self = this;
          items.forEach(function (item) {
            if (item.block === false && item.id != self.resize.id && !item.move) {
              let x1 = self.resize.ix;
              let x2 = item.ix;
              self.resize.ix = x2;
              item.ix = x1;
              item.newPos = { x: self.indx[item.ix].x, y: self.indx[item.ix].y };
              item.move = true;
              self.movesTo.push(item);
            }
          });
        }
        this.stage.update();
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        this.resize.newPos = { x: this.indx[this.resize.ix].x, y: this.indx[this.resize.ix].y };
        this.movesTo.push(this.resize);
        this.stage.update();
        this.stage.removeAllEventListeners('stagemousemove');
      }
    },
    anim(bmp) {
      let count = 20;
      if (Math.abs(bmp.x - bmp.newPos.x) < count) bmp.x = bmp.newPos.x;
      if (bmp.x < bmp.newPos.x) bmp.x += count;
      else if (bmp.x > bmp.newPos.x) bmp.x -= count;
      if (Math.abs(bmp.y - bmp.newPos.y) < count) bmp.y = bmp.newPos.y;
      if (bmp.y < bmp.newPos.y) bmp.y += count;
      else if (bmp.y > bmp.newPos.y) bmp.y -= count;
    },
    tick(e) {
      if (this.movesTo.length > 0) {
        for (let i = 0; i < this.movesTo.length; i++) {
          this.anim(this.movesTo[i]);
          if (this.movesTo[i].x == this.movesTo[i].newPos.x && this.movesTo[i].y == this.movesTo[i].newPos.y) {
            this.movesTo[i].move = false;
            this.movesTo.splice(i, 1);
          }
        }
        this.stage.update();
      }
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var solv = [];
      for (let i = 0; i < this.indx.length; i++) {
        for (let j = 0; j < this.images.length; j++) {
          if (this.images[j].ix == i) {
            solv.push({ id: this.images[j].id, ix: j });
            break;
          }
        }
      }
      for (let i = 0; i < solv.length; i++) {
        if (solv[i].id != this.initData.correct[i]) isCorrect = false;
        else if (this.initData.corrBlock !== false) {
          this.images[solv[i].ix].block = true;
        }
      }
      if (isCorrect) {
        this.images.forEach(function (bmp) {
          bmp.block = true;
        });
      }
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
    objectImageExist(item) {
      return (_.isObject(item) && !_.isNil(item.imagePath)) || _.isArray(item);
    },
    getImage(item) {
      return this.getImageSrc(item.imagePath);
      // return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
    this.ticker.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 10px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
  .image-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 24%;
    padding-bottom: 1%;
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}

canvas {
}
</style>
